import Vue from 'vue'   //引入Vue
import Router from 'vue-router'  //引入vue-router
import index from '@/view/index'  //引入根目录下的index.vue组件
import eventSignin from '../view/eventSignin'

Vue.use(Router);  //Vue全局使用Router

export default new Router({
   // mode: 'history',  //去掉url中的#

   routes: [              //配置路由，这里是个数组
      {                    //每一个链接都是一个对象
         path: '/',         //链接路径
         name: 'index',     //路由名称，
         component: index   //对应的组件模板
      },
      {
         path:'/eventSignin',
         name:'eventSignin',
         component:eventSignin,
      },
      {
         path:'*',
         redirect: '/'
      },
   ]
})

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return routerPush.call(this, location).catch(error=> error)
}